import { useState } from "react"

export const useGlobalStates = () => {
    
    const [ showForm, setShowForm ] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [showConfirmPassword, setShowConfirmPassword] = useState(false)
    const [loadingSubmitForm, setLoadingSubmitForm] = useState(false)

    return Object.freeze({
        showForm, setShowForm,
        showPassword, setShowPassword,
        showConfirmPassword, setShowConfirmPassword,
        loadingSubmitForm, setLoadingSubmitForm
    })
}